$(document).ready(function() {

    $('#portals_tickets_personal_info_checked').click(function(){
        var _checkbox = $(this)
        var _submit_button = $('#portals_tickets_submit_button')

        if(_checkbox.is(':checked')){
            _submit_button.attr("disabled", false);
        } else{
            _submit_button.attr("disabled", true);
        }
    });

});
